import { get } from 'lodash';
import { createSelector } from 'reselect';
import { formValueSelector } from 'redux-form';

export const getScopeFromSettings = state =>
  get(state.productSettings, 'value.scope');

export const getAllowedActionsFromSettings = state =>
  get(state.productSettings, 'value.allowed_actions');

const getAccessPermissionsFromSettings = state =>
  formValueSelector('role')(state, 'apps');

export const getApplicationAccessPermission = createSelector(
  [
    getScopeFromSettings,
    getAccessPermissionsFromSettings,
    getAllowedActionsFromSettings,
  ],
  (scope, appsPermissions, allowedActions = []) => {
    const hasPermission = allowedActions.length === 1;
    const permissionValue = !!get(appsPermissions, `${scope}.${scope}.value`);

    return hasPermission ? permissionValue : undefined;
  },
);
